// src/store/notificationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: [],
  reducers: {
    addNotification: (state, action) => {
      const {
        type,
        message,
        isPersistent = false,
        timeout = 5000,
      } = action.payload;
      const id = Date.now() + Math.random();
      state.push({ id, type, message, isPersistent, timeout });
    },
    removeNotification: (state, action) => {
      return state.filter((notification) => notification.id !== action.payload);
    },
    // --- ARC's Note: ACCIÓN DE LIMPIEZA DEFINITIVA ---
    // Este reducer resetea el array de notificaciones a un estado vacío.
    clearNotifications: () => {
      return [];
    },
  },
});

export const { addNotification, removeNotification, clearNotifications } =
  notificationSlice.actions;
export default notificationSlice.reducer;
